import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "./UI";

const FOOTER_NAV = [
  { label: "Overview", path: "/" },
  { label: "What We Do", path: "/services" },
  { label: "Our Story", path: "/about" },
  { label: "Insights", path: "/blog" },
  { label: "Let's Talk", path: "/contact" },
];

const FOOTER_CONNECT = [
  { label: "Instagram", href: "https://www.instagram.com/ovardigital/", external: true },
  { label: "LinkedIn", href: "https://www.linkedin.com/company/ovard-digital/", external: true },
  { label: "WhatsApp", href: "https://wa.me/917975034116", external: true },
  { label: "Email", href: "mailto:ovarddigital@gmail.com", external: false },
];

export default function Footer() {
  return (
    <footer className="footer">

      {/* Top CTA band */}
      <div className="footer-cta-band">
        <div className="container footer-cta-inner">
          <div className="footer-cta-text">
            <span className="footer-cta-eyebrow">Ready to grow?</span>
            <h3 className="footer-cta-heading">Let's build something worth noticing.</h3>
          </div>
          <Link to="/contact" className="footer-cta-btn">
            Start a conversation
            <svg width="14" height="10" viewBox="0 0 14 10" fill="none">
              <path d="M8 1L13 5L8 9" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M13 5H1" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
            </svg>
          </Link>
        </div>
      </div>

      {/* Main footer body */}
      <div className="footer-body">
        <div className="container">

          {/* Brand row */}
          <div className="footer-brand-row">
            <div className="footer-brand-left">
              <Link to="/" aria-label="OVARD Digital — home">
                <Logo height={32} />
              </Link>
              <p className="footer-slogan">Your Brand. Our Strategy. Unlimited Growth.</p>
            </div>
            <div className="footer-cols">
              <div className="footer-col">
                <h4>Navigate</h4>
                {FOOTER_NAV.map((l) => (
                  <Link key={l.label} to={l.path}>{l.label}</Link>
                ))}
              </div>
              <div className="footer-col">
                <h4>Connect</h4>
                {FOOTER_CONNECT.map((l) => (
                  <a
                    key={l.label}
                    href={l.href}
                    {...(l.external ? { target: "_blank", rel: "noopener noreferrer me" } : {})}
                  >
                    {l.label}
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Big wordmark */}
          <div className="footer-wordmark" aria-hidden="true">OVARD</div>

          {/* Bottom strip */}
          <div className="footer-bottom">
            <span className="footer-copy">© 2026 OVARD Digital. All rights reserved.</span>
            <address className="footer-address" style={{ fontStyle: "normal", fontSize: "0.8rem", opacity: 0.5 }}>
              Mysore, Karnataka, India · <a href="mailto:ovarddigital@gmail.com" style={{ color: "inherit" }}>ovarddigital@gmail.com</a>
            </address>
            <span className="footer-legal">Built for brands that mean business.</span>
          </div>

        </div>
      </div>

    </footer>
  );
}
